import React from 'react';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { WideOfferApplyButton } from '../fragments/OfferApplyButtons/WideOfferApplyButton';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import './StandarBusinessLoanOffer.scss';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';

const BusinessLoanOfferNameAndInfo = ({
  datatestid,
  offerDetails,
  seenPixel,
}) => {
  const hasBullets = offerDetails.bullets.length > 0;
  return (
    <FlexContainer className="flex-column padR24 mobilePadR0">
      <div>
        <div className="text-14 bold margB16 t-text-center m-margT16 m-margB24">
          {offerDetails.headline}
          {seenPixel}
        </div>

        <div className="desktopHide format100">
          <OfferDetail
            title="APR"
            description={`Starting at ${offerDetails.apr}%`}
            tooltip={offerDetails.aprTooltip}
            isMobileView
          />
          <OfferDetail
            title="Term"
            description={`Up to ${offerDetails.termMonths} mo.`}
            isMobileView
          />
          <OfferDetail
            title="Loan amount"
            description={offerDetails.loanAmount}
            isMobileView
          />
        </div>
      </div>
      {hasBullets && (
        <div dangerouslySetInnerHTML={{ __html: offerDetails.bullets }} />
      )}
    </FlexContainer>
  );
};

const OfferDetail = props => {
  const { title, description, tooltip, isMobileView } = props;
  const content = (
    <div
      className={`${
        isMobileView ? 'flex-container justify-between align-items-center' : ''
      }`}
    >
      <div className="text-12">
        {title}
        {tooltip && (
          <CSTooltip
            tooltipName="APR Disclosure"
            isInline={true}
            title={tooltip}
            placement="bottom"
            vertical={CREDIT_CARD_VERTICAL}
          >
            <InfoCircleOutlined
              style={{
                display: 'inline-block',
                position: 'relative',
                top: -4,
              }}
            />
          </CSTooltip>
        )}
      </div>
      <div className="text-20 bold m-text-16 m-margB8">{description}</div>
    </div>
  );
  if (isMobileView) {
    return <div className="format100 gray7">{content}</div>;
  }
  return (
    <Row fullWidth className="margLR24 width33 gray7">
      {content}
    </Row>
  );
};

const StandardBusinessLoanOffer = ({
  datatestid,
  offerMetadata: offerDetails,
  clickApplyHandler,
  clickApplyImageHandler,
  seenPixel,
}) => {
  return (
    <SectionContainer className="StandardBusinessLoanOffer grayShadow offerCard m-marglrAuto">
      <Row className="offerCardRow margB0">
        <FlexContainer className="align-items-start flex-tablet-col">
          <div className="t-width100 t-text-center">
            <img
              data-testid={`${datatestid}-bl-offer-image`}
              className="businessLoanOfferImage padR24 mobilePadR0 m-padB16"
              src={offerDetails.logoLink}
              alt="Business Loan Offer"
              onClick={clickApplyImageHandler}
            />
          </div>

          <FlexContainer className="justify-between format100 flex-tablet-col">
            <BusinessLoanOfferNameAndInfo
              datatestid={`${datatestid}-bl-offer`}
              offerDetails={offerDetails}
              seenPixel={seenPixel}
            />
            <WideOfferApplyButton
              datatestid={`${datatestid}-offer`}
              partnerName={offerDetails.name}
              clickApplyHandler={clickApplyHandler}
            />
          </FlexContainer>
        </FlexContainer>
      </Row>
      <Row className="tabletHide divider" />
      <FlexContainer className="tabletHide justify-between">
        <OfferDetail
          title="APR"
          description={`Starting at ${offerDetails.apr}%`}
          tooltip={offerDetails.aprTooltip}
        />
        <OfferDetail
          title="Term"
          description={`Up to ${offerDetails.termMonths} mo.`}
        />
        <OfferDetail title="Loan amount" description={'$5,000 - $250,000'} />
      </FlexContainer>
    </SectionContainer>
  );
};

export { StandardBusinessLoanOffer };
